import dayjs from 'dayjs'

/**
 * 格式化日期
 */
export function formatDate(date, format = 'YYYY-MM-DD') {
  if (!date) return ''
  return dayjs(date).format(format)
}

export function formatTime(date) {
  if (!date) return ''
  return dayjs(date).format('YYYY-MM-DD HH:mm')
}

/**
 * 格式化金额
 */
export function formatPrice(price) {
  if (!price && price !== 0) return '¥0.00'
  return `¥${parseFloat(price).toFixed(2)}`
}

/**
 * 格式化数字（千位分隔符）
 */
export function formatNumber(num) {
  if (!num && num !== 0) return '0'
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * 获取相对时间（如"2小时前"）
 */
export function getRelativeTime(date) {
  if (!date) return ''
  const now = dayjs()
  const target = dayjs(date)
  const diff = now.diff(target, 'second')

  if (diff < 60) {
    return '刚刚'
  } else if (diff < 3600) {
    return `${Math.floor(diff / 60)}分钟前`
  } else if (diff < 86400) {
    return `${Math.floor(diff / 3600)}小时前`
  } else if (diff < 604800) {
    return `${Math.floor(diff / 86400)}天前`
  } else {
    return target.format('YYYY-MM-DD')
  }
}

/**
 * 订单状态机（与后端 OrderStatus 枚举对齐）：
 * 0待支付 1待出行 2待确认 3已确认 4已完成 5已取消 6退款中 7已退款 8已驳回 9待发货 10已发货 11已收货
 * （9/10/11 为邮寄模式专用，H5 端仅支持日历价出行人下单，理论上不会出现，仍一并列出以防止状态缺失导致的显示异常）
 */
// canCancel/canRefund 与后端 OrderStatusService.UserCancel/UserApplyRefund 的状态白名单严格对齐：
// 可取消：0待支付/2待确认/3已确认；可退款：1待出行/3已确认/4已完成/9待发货/10已发货
const ORDER_STATUS_MAP = {
  0: { text: '待支付', color: '#f59e0b', canPay: true, canCancel: true, canRefund: false },
  1: { text: '待出行', color: '#ff720d', canPay: false, canCancel: false, canRefund: true },
  2: { text: '待确认', color: '#8b5cf6', canPay: false, canCancel: true, canRefund: false },
  3: { text: '已确认', color: '#10b981', canPay: false, canCancel: true, canRefund: true },
  4: { text: '已完成', color: '#10b981', canPay: false, canCancel: false, canRefund: true },
  5: { text: '已取消', color: '#6b7280', canPay: false, canCancel: false, canRefund: false },
  6: { text: '退款中', color: '#f59e0b', canPay: false, canCancel: false, canRefund: false },
  7: { text: '已退款', color: '#ef4444', canPay: false, canCancel: false, canRefund: false },
  8: { text: '已驳回', color: '#ef4444', canPay: false, canCancel: false, canRefund: false },
  9: { text: '待发货', color: '#ff720d', canPay: false, canCancel: false, canRefund: true },
  10: { text: '已发货', color: '#ff720d', canPay: false, canCancel: false, canRefund: true },
  11: { text: '已收货', color: '#10b981', canPay: false, canCancel: false, canRefund: false }
}

/**
 * 获取订单状态完整信息：{ text, color, canPay, canCancel, canRefund }
 */
export function getOrderStatusInfo(status) {
  return ORDER_STATUS_MAP[status] || { text: String(status), color: '#6b7280', canPay: false, canCancel: false, canRefund: false }
}

/**
 * 获取订单状态文本
 */
export function getOrderStatusText(status) {
  return getOrderStatusInfo(status).text
}

/**
 * 获取订单状态颜色
 */
export function getOrderStatusColor(status) {
  return getOrderStatusInfo(status).color
}
